<template>
	<div class="c-member">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'memberList'
	}
</script>

<style lang="stylus" scoped>
	.c-member {
		display: grid;
		grid-gap: .14rem;
		grid-template-columns: repeat(2, 1fr);
		padding: .24rem 0;

		>>> &-item {
			gap: .24rem;
			position: relative;
			border-radius: .08rem;
			padding: .1rem .12rem;
			background: #F9F9F9;
			
			.name {
				font-size: .3rem;
				color: #333;
			}

			.tag {
				border-radius: .04rem;
				padding: 0 .08rem;
				margin-left: .08rem;
				line-height: .36rem;
				font-size: .22rem;
				white-space: nowrap;
				color: #00ACA9;
				background: #E5F3F3;
			}

			.post {
				margin-top: .2rem;
				font-size: .22rem;
				color: #91A1B9;
			}

			.tel {
				position: absolute;
				inset: 0;

				.tf {
					position: absolute;
					right: .1rem;
					bottom: .1rem;
					font-size: .28rem;
					color: var(--color-main);
				}
			}

			.remove {
				position: absolute;
				right: 0;
				top: 0;
				width: .28rem;
				height: .28rem;
				border-radius: 50%;
				font-size: .16rem;
				color: #fff;
				background: #f55;
			}
		}
	}
</style>
